var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    !_vm.fetchingOutputPreset && !_vm.fetchingEmptyOutputPreset && _vm.checkedIfSystem
  )?_c('output-preset-form',{attrs:{"edit":"","submit-loading":_vm.editingOutputPreset},on:{"submit":_vm.editOutputPreset}}):_c('loading-page')}
var staticRenderFns = []

export { render, staticRenderFns }